<template>
  <div class="seomain">
    <st-header
      title="收款管理"
      :back-able="true"
			:more-op="[{ val: 'download', title: '下载收款单' }, { val: 'startbatch', title: '批量处理' }]"
			@command="headercommand"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
      </template>
    </st-header>

    <ul class="tab-tilte four">
      <li
        v-for="(item, index) in tabs"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ item.title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <div class="keyword">
      <div class="keyword-search-panel">
        <van-search
          v-model="scode"
          shape="round"
          show-action
          background="transparent"
          placeholder="请输入收款单号搜索"
          @search="onSearch"
          @cancel="onCancel"
        />
      </div>
    </div>
    <div class="tab-content tab-content-list">
      <div class="st-list-box pan-3">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				  <div class="st-list" v-for="(v, k) in stlist" :key="v.id" :index="k">
				    <div class="st-list-top st-list-top-with-status">
							<div class="t-tit">{{ v.code }}</div>
				    </div>
				    <div class="st-list-main"
				    	@touchstart="touchstart"
				    	@touchmove="touchmove"
				    	@touchend="touchend"
				    	@click="checkItem(v.id)"
				    >
							<div class="list-checkbox" v-if="touchLong">
								<!-- <van-checkbox :model="checkList[v.id]"></van-checkbox> -->
								<van-checkbox :value="checkList[v.id]"></van-checkbox>
							</div>
              <div class="st-summary-row">
                <div class="st-summary-card">
                  <div class="st-summary-label">收款金额</div>
                  <div class="st-summary-value">{{ v.amount }} {{ v.currency }}</div>
                </div>
                <div class="st-summary-card">
                  <div class="st-summary-label">是否逾期</div>
                  <div class="st-summary-value" :class="{ 'is-danger': v.is_expire }">{{ v.is_expire ? '已逾期' : '未逾期' }}</div>
                </div>
              </div>
              <div class="st-field"><span class="st-field-label">销售单号</span><span class="st-field-value">{{ v.order_code || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">往来单位</span><span class="st-field-value">{{ v.supplier || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">收款单位</span><span class="st-field-value">{{ v.company || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">客户经理</span><span class="st-field-value">{{ v.seller || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">提单人</span><span class="st-field-value">{{ v.orderoperator || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">订单类型</span><span class="st-field-value">{{ v.order_type_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">收款方式</span><span class="st-field-value">{{ v.type_text || '--' }}</span></div>
              <div class="st-field"><span class="st-field-label">订单金额</span><span class="st-field-value">{{ v.orderamount }} {{ v.ordercurrency }}</span></div>
              <div class="st-field"><span class="st-field-label">应收金额</span><span class="st-field-value">{{ v.receivable }} {{ v.currency }}</span></div>
              <div class="st-field"><span class="st-field-label">已出库金额</span><span class="st-field-value">{{ v.sendamount }} {{ v.ordercurrency }}</span></div>
              <div class="st-field"><span class="st-field-label">已出库未收款</span><span class="st-field-value">{{ v.sendarrears }} {{ v.ordercurrency }}</span></div>
              <div class="st-field"><span class="st-field-label">应收时间</span><span class="st-field-value">{{ (!v.predicttime_text || v.predicttime_text == "1970年01月01日 08:00" || v.predicttime_text == "1970-01-01 08:00:00") ? '未出库' : v.predicttime_text }}</span></div>
              <div class="st-field"><span class="st-field-label">收款时间</span><span class="st-field-value">{{ (!v.paymenttime_text || v.paymenttime_text == "1970年01月01日 08:00" || v.paymenttime_text == "1970-01-01 08:00:00") ? '未出库' : v.paymenttime_text }}</span></div>
              <div class="st-field"><span class="st-field-label">创建时间</span><span class="st-field-value">{{ v.createdatetime || '--' }}</span></div>
				    </div>
						<div class="st-list-bottom-2">
							<div class="st-action-wrap" v-if="v.status == 0 || v.status == -1">
								<div class="st-list-bottom-xs st-action-edit">
									<router-link :to="'/incomeorder/save/' + v.id" class="st-opt-btn">编辑</router-link>
								</div>
							</div>
							<van-button v-if="v.status == 2" @click="openApproveDetail(v.id)" type="primary" class="st-opt-btn st-action-btn">审批详情</van-button>
							<div class="st-action-wrap" v-if="v.status == 0 || v.status == -1">
								<div class="st-list-bottom-xs st-action-confirm">
									<router-link :to="'/incomeorder/receipt/' + v.id" class="st-opt-btn">确认收款</router-link>
								</div>
							</div>

							<!-- <van-button v-if="v.status == 0"  @click="approval(v.id)" type="info" class="st-opt-btn" style="flex: 1;">提交申请</van-button> -->
						</div>
				   
				  </div>
				</van-list>
			</div>
      
			<batch-btn
				v-if="touchLong"
				:options="batchBtnOptions[type]"
				@command="batchCommand"
			></batch-btn>
		</div>

  </div>
</template>

<script>
import StHeader from "@/components/layout/Header.vue";
import BatchBtn from "@/components/layout/BatchBtn.vue";
export default {
  components: {
    "st-header": StHeader,
		'batch-btn': BatchBtn,
  },
  props: {},
	inject: ['reload'],
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
			tabs: [
				{ title: '全部', type: '0' },
				{ title: '待审核', type: '1' },
				{ title: '审核中', type: '2' },
				{ title: '已收款', type: '3' },
			],
      cur: 0,
			type: 0,
      show: !1,
			
			mode: this.$route.params.mode,
      oneinfo: {},
      stlist: [],
      scode: "", // 关键字搜索
			
			// 批量操作相关
			checkList: {},
			batchBtnOptions: {},
			touchLong: false,
			
    };
  },
  watch: {
  	touchLong: function(nv, ov) {
  		this.checkList = {};
  		this.$forceUpdate();
  	}
  },
  computed: {},
  methods: {
		
		// 更多里的操作
		headercommand(val) {
			this[val]();
		},
		
		/**
		 * 下载收款单
		 */
		async download() {
			let type = this.tabs[this.cur]['type'];
			let params = {
			  code: this.scode,
			  status: type,
			  type: this.mode,
				token: window.localStorage.getItem("sto_user_token"),
			}
			
			await this.$post(this.$api.stIncomeOrderDownloadOrder, params).then((res) => {
				window.location.href = res.data;
			})
			
		},
		
		// 开启批量模式
		startbatch() {
			this.touchLong = true;
		},
		
    // 添加
    addOrder() {
      this.$router.push(`/incomeorder/save/0`);
    },
		
		// 提交申请
		approval(id) {
			this.$post(this.$api.stCustomerApproval, {'ids': id}).then((res) => {
				if (res.code == 1) {
					this.$toast.success('提交成功');
				} else {
					this.$toast.fail((res.msg ? res.msg : '提交异常，请稍后重试'));
				}
			});
		},
		// 查看审批详情
		openApproveDetail(id) {
			this.$router.push(`/common/approveDetail/4?id=${id}`);
		},
   
    async get_st_list(e) {
      this.stlist = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("incomeorder_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
				this.type = this.tabs[activeIndex].type;
      }
			
			this.setBatchBtnOption();
    },
    changeActiveIndex(value) {
			this.touchLong = false;
      this.cur = value;
			this.type = this.tabs[value].type;
      window.sessionStorage.setItem("incomeorder_activeIndex", value);
    },
    // 分页
    async onLoad() {
			let type = this.tabs[this.cur]['type'];
      let result = await this.$post(this.$api.stIncomeOrderList, {
        code: this.scode,
        tag: type,
        page: this.page,
      });
      if (result.data.list.length == 0) return (this.finished = true);
      // 进行操作
      this.stlist.push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },

    onSearch(val) {
			this.touchLong = false;
      this.stlist= [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
		
		// #region-start 批量操作相关方法
		// 开始触屏
		touchstart() {
			this.touchTimeOut = setTimeout(() => {
				this.touchLong = true;
			}, 2500)
		},
		touchmove() {
			clearTimeout(this.touchTimeOut);
		},
		touchend() {
			clearTimeout(this.touchTimeOut);
		},
		
		// 勾选
		checkItem(id) {
			this.checkList[id] = !this.checkList[id];
			this.$forceUpdate();
		},
		getCheckIds() {
			let ids = [];
			for (let i in this.checkList) {
				if (this.checkList[i]) {
					ids.push(i);
				}
			}
			
			return ids;
		},
		// 设置 批量操作的按钮
		setBatchBtnOption() {	
			let options = {};
			let oprator = {
				"del": { text: '删除', value: 'del' },
				"return": { text: '撤回', value: 'return' },
			};
			let option = [
				{ text: '操作', children: [],
				}
			];
			
			for(let tit in this.tabs) {
				let v = this.tabs[tit];
				let children = [];
				if (v.type == 0) {
					children = ['del', 'return'];
				}  else if (v.type == 1) {
					children = ['del'];
				} else if (v.type == 2) {
					children = [];
				} else if (v.type == 3) {
					children = ['return'];
				}
				if (children.length > 0)  options[v.type] = JSON.parse(JSON.stringify(option));
	
				children.forEach((child) => {
					if (options[v.type]) {
						options[v.type][0].children.push(oprator[child]);
					}
					
				})
			}
			
			this.batchBtnOptions = options;
		},
		// 批量处理
		batchCommand(sign, params) {
			console.log(sign);
			if (sign == 'cancel') {
				this.touchLong = false;
				return;
			}
			
			let checkedIds = this.getCheckIds();
			if (!checkedIds || Object.keys(checkedIds).length <= 0) {
				this.$toast.fail('请选择收款单');
				return;
			}
		
			// 删除
			if (sign == 'del') {
				this.del(checkedIds, this.$api.stIncomeOrderDel);
			} else if (sign == 'return') {
				this.return(checkedIds);
			}
		},
		
		// 删除订单
		del(id, api) {
			this.$confirm('您正在进行收款单删除操作，是否继续进行？').then((data) => {
				this.$post(api, {ids: id.join(',')}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('删除成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了删除操作');
			});
		},
		
		
		// 撤回订单
		return(id) {
			this.$confirm('您正在进行收款单撤回操作，是否继续进行？').then((data) => {
				this.$post(this.$api.stIncomeOrderReturn, {ids: id.join(',')}).then((res) => {
					if (res.code == 1) {
						this.$toast.success('撤回成功');
						this.reload();
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
				})
			}).catch((e) => {
				console.log('您取消了撤回操作');
			});
		},
		// #region-edn 批量操作相关方法
		
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.st-list-box{
	margin: 0px 24px;
	.st-list {
		border-radius: 5px;
	}
}
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}

.st-list-bottom-xs {
  border-radius: 5px;
  font-size: 14px;
}

.keyword {
  position: fixed;
  margin-bottom: 16px;
  width: 100%;
  top: 98px;
}

.keyword-search-panel {
  margin: 0 12px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #eceff5;
  overflow: hidden;
  box-shadow: none;
}

.keyword-search-panel .van-search {
  padding-left: 16px;
  padding-right: 16px;
}
.four li {
  width: 25%;
}
.st-list-bottom-xs {
  background: #677588;
}
.pan-2 .t-tit {
  border-left: 3px solid #43cf7c;
}
.pan-3 .t-tit {
  border-left: 3px solid #ff5733;
}

.st-list-bottom-2,.st-list-bottom-3 {
	background-color: white;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	width: 100%;
  gap: 8px;
}

.st-list-bottom-2 {
	.van-button {
		margin-top: 8px;
		width: auto;
		border-radius: 8px;
	}
}

.st-list-bottom-3 {
	.van-button {
		width: 30%;
		border-radius: 8px;
	}
}

.st-list-bottom-diy {
  display: flex;
}
.st-list-bottom-diy .st-diyl-btn {
  background: #677588;
  border-radius: 5px;
  flex: 1;
  margin-right: 8px;
}
.st-list-bottom-diy .st-diyr-btn {
  background: #00baad;
  border-radius: 5px;
  flex: 1;
  margin-left: 8px;
}

.st-list-main {
	position: relative;
  padding-top: 4px;
  padding-bottom: 4px;
  .st-summary-row {
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .st-summary-card {
    flex: 1;
    min-width: 0;
    padding: 10px 12px;
    border-radius: 10px;
    background: #f7f9fc;
  }
  .st-summary-label {
    color: #8a93a3;
    font-size: 12px;
    line-height: 1.2;
  }
  .st-summary-value {
    margin-top: 6px;
    color: #394150;
    font-size: 16px;
    font-weight: 600;
    word-break: break-all;
  }
  .st-field {
    display: flex;
    align-items: flex-start;
    padding: 6px 0;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px dashed #f1f3f7;
  }
  .st-field:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
  .st-field-label {
    flex: 0 0 110px;
    color: #7d8697;
  }
  .st-field-label::after {
    content: "：";
  }
  .st-field-value {
    flex: 1;
    min-width: 0;
    color: #394150;
    word-break: break-all;
  }
  .st-field-value.is-danger {
    color: #e24d4f;
    font-weight: 600;
  }
  .st-summary-value.is-danger {
    color: #e24d4f;
  }
	.list-checkbox {
		position: absolute;
		top: 10px;
		right: 20px;
	}
}
</style>
<style lang="scss" scoped>
.tab-content-list {
  padding-top: 88px;
}
.tab-tilte.four {
  display: flex;
  overflow-x: hidden;
  height: 62px;
  min-height: 62px;
  align-items: center;
  padding: 2px 0 4px;
  box-sizing: border-box;
}
.tab-tilte.four .text-center {
  flex: 1;
  min-width: 0;
  height: 100%;
}
.tab-tilte.four .text-center span {
  font-size: 14px;
  line-height: 1;
}
.tab-tilte.four .active span {
  display: block;
  margin: 0 4px;
  padding: 10px 10px;
  border-radius: 999px;
}
.st-list-top-with-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.st-list-top-with-status .t-tit {
  flex: 1;
  min-width: 0;
}
.st-list-top-with-status .t-status {
  flex: 0 0 auto;
  color: #2a82e4;
  font-weight: 600;
}
.st-action-wrap {
  flex: 1;
  padding: 0 8px;
  height: 44px;
  min-width: 0;
}
.st-list-bottom-2 > .st-action-wrap,
.st-list-bottom-2 > .st-action-btn {
  flex: 1 1 0;
  min-width: 0;
}
.st-action-btn,
.st-action-wrap .st-list-bottom-xs {
  margin-top: 0;
  height: 42px;
  line-height: 42px;
  border-radius: 5px;
}
.st-action-btn {
  flex: 1 1 0;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.st-action-wrap .st-list-bottom-xs {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.st-action-wrap .st-opt-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 0;
  padding-top: 0;
  line-height: 1;
  text-align: center;
}
.st-action-edit {
  background-color: orange;
}
.st-action-confirm {
  background-color: #18bc9c;
}
.st-btn-3 {
	width: 30%;
	height: 50%;
	border-radius: 5px;
}
</style>
